import { IPaymentOperation } from "./PaymentOperation";

export type PaymentType = 'reimbursement' | 'point' | 'commission' | 'delivery' | 'expense' | 'bonus' | 'deposit' ;


export interface IPayment {
    id: number,
    
    ownerId: number,
    bearerId: number,
    description: string,
    issueDate: Date,
    totalAmount: number,
    tax: number,
    accessories: number,
    amount: number,
    isCancelled: boolean,
    cancellationDate: Date,
    cancellationPurpose: string,
    
    type: PaymentType,

    remainingAmount: number,

    tellerOperationId: number,

    ownerName: string,
    bearerName: string,

    paymentOperations: IPaymentOperation[],
  }
  

  export const defaultPayment : IPayment = {
    id: 0,
    
    ownerId: 0,
    bearerId: 0,
    description: '',
    issueDate: new Date(),
    totalAmount: 0,
    tax: 0,
    accessories: 0,
    amount: 0,
    isCancelled: false,
    cancellationDate: new Date(),
    cancellationPurpose: '',
    
    remainingAmount: 0,

    type: 'reimbursement',

    tellerOperationId: 0,

    ownerName: '',
    bearerName: '',

    paymentOperations: [],
  }

  export interface IPaymentSearch {
    startDate: Date,
    endDate: Date,
    
    description: string,
    
    ownerName: string,
    bearerName: string,
  }